import React, { useState } from 'react';
import { FaArrowRight, FaCircle, FaFont, FaCheck } from 'react-icons/fa';

const AnnotationTools = ({ onToolSelect, selectedTool, onTextAdd }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [showTextInput, setShowTextInput] = useState(false);
  const [textInput, setTextInput] = useState('');

  const annotationTools = [
    { id: 'arrow', name: 'Arrow', icon: FaArrowRight, description: 'Draw arrows' },
    { id: 'circle', name: 'Circle', icon: FaCircle, description: 'Circle areas' },
    { id: 'text', name: 'Text', icon: FaFont, description: 'Add text labels' },
  ];

  const handleToolSelect = (tool) => {
    if (tool.id === 'text') {
      setShowTextInput(true);
    } else if (tool.id === 'arrow') {
      // Add arrow to canvas immediately
      const canvasWidth = window.innerWidth - 400;
      const canvasHeight = window.innerHeight - 100;
      const centerX = canvasWidth / 2;
      const centerY = canvasHeight / 2;
      
      // Create a default arrow pointing right
      const arrowShape = {
        id: `arrow-${Date.now()}`,
        type: 'arrow',
        x1: centerX - 50,
        y1: centerY,
        x2: centerX + 50,
        y2: centerY,
        color: 0x222222
      };
      
      // Add the arrow shape to the canvas
      window.dispatchEvent(new CustomEvent('addShape', {
        detail: { shape: arrowShape }
      }));
      
      onToolSelect(tool);
      setIsOpen(false);
    } else {
      onToolSelect(tool);
      setIsOpen(false);
    }
  };

  const handleTextSubmit = () => {
    if (textInput.trim()) {
      onTextAdd(textInput.trim());
      setTextInput('');
      setShowTextInput(false);
      setIsOpen(false);
    }
  };

  const handleTextCancel = () => {
    setTextInput('');
    setShowTextInput(false);
  };

  return (
    <div style={{ position: 'relative', display: 'inline-block' }}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        style={{
          padding: '8px 12px',
          border: 'none',
          borderRadius: '6px',
          background: selectedTool 
            ? 'linear-gradient(135deg, #4CAF50 0%, #45a049 100%)' 
            : 'linear-gradient(135deg, #1a1a1a 0%, #404040 100%)',
          color: 'white',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          fontSize: '14px',
          fontWeight: '600'
        }}
      >
        <FaArrowRight />
        Annotations
      </button>

      {isOpen && (
        <div
          style={{
            position: 'fixed',
            top: '240px', // Fixed position from top of viewport
            right: '420px', // Fixed position from right of viewport (outside toolbar)
            background: 'linear-gradient(135deg, #1a1a1a 0%, #404040 100%)',
            border: '1px solid #333',
            borderRadius: '8px',
            padding: '16px',
            zIndex: 2500,
            minWidth: '200px',
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)'
          }}
        >
          {!showTextInput ? (
            <>
              <div style={{ marginBottom: '12px', fontWeight: 'bold', color: 'white' }}>
                Annotation Tools
              </div>
              
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                {annotationTools.map((tool) => {
                  const IconComponent = tool.icon;
                  return (
                    <div
                      key={tool.id}
                      onClick={() => handleToolSelect(tool)}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '12px',
                        padding: '12px',
                        borderRadius: '6px',
                        cursor: 'pointer',
                        background: selectedTool?.id === tool.id ? 'rgba(255,255,255,0.2)' : 'transparent',
                        transition: 'background 0.2s ease',
                        border: selectedTool?.id === tool.id ? '1px solid rgba(255,255,255,0.3)' : '1px solid transparent'
                      }}
                    >
                      <IconComponent style={{ color: 'white', fontSize: '16px' }} />
                      <div>
                        <div style={{ color: 'white', fontWeight: '600', fontSize: '14px' }}>
                          {tool.name}
                        </div>
                        <div style={{ color: 'rgba(255,255,255,0.7)', fontSize: '12px' }}>
                          {tool.description}
                        </div>
                      </div>
                      {selectedTool?.id === tool.id && (
                        <FaCheck style={{ color: 'white', fontSize: '14px', marginLeft: 'auto' }} />
                      )}
                    </div>
                  );
                })}
              </div>
            </>
          ) : (
            <>
              <div style={{ marginBottom: '12px', fontWeight: 'bold', color: 'white' }}>
                Add Text Label
              </div>
              
              <div style={{ marginBottom: '12px' }}>
                <input
                  type="text"
                  value={textInput}
                  onChange={(e) => setTextInput(e.target.value)}
                  placeholder="Enter text..."
                  style={{
                    width: '100%',
                    padding: '8px 12px',
                    border: '1px solid rgba(255,255,255,0.3)',
                    borderRadius: '4px',
                    background: 'rgba(255,255,255,0.1)',
                    color: 'white',
                    fontSize: '14px',
                    boxSizing: 'border-box'
                  }}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      handleTextSubmit();
                    } else if (e.key === 'Escape') {
                      handleTextCancel();
                    }
                  }}
                  autoFocus
                />
              </div>
              
              <div style={{ display: 'flex', gap: '8px' }}>
                <button
                  onClick={handleTextSubmit}
                  style={{
                    flex: 1,
                    padding: '8px 12px',
                    border: 'none',
                    borderRadius: '4px',
                    background: 'linear-gradient(135deg, #4CAF50 0%, #45a049 100%)',
                    color: 'white',
                    cursor: 'pointer',
                    fontSize: '12px',
                    fontWeight: '600'
                  }}
                >
                  Add Text
                </button>
                <button
                  onClick={handleTextCancel}
                  style={{
                    flex: 1,
                    padding: '8px 12px',
                    border: 'none',
                    borderRadius: '4px',
                    background: 'rgba(255,255,255,0.1)',
                    color: 'white',
                    cursor: 'pointer',
                    fontSize: '12px',
                    fontWeight: '600'
                  }}
                >
                  Cancel
                </button>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default AnnotationTools; 